import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_REQUEST_FREE_TREAT_GIFT_AND_DELAY_METHOD = "POST";
export const SUBSCRIPTIONS_CUSTOMER_GET_FREE_TREAT_GIFT_METHOD = "GET";

export const SUBSCRIPTIONS_CUSTOMER_REQUEST_FREE_TREAT_GIFT_AND_DELAY_PATH_SUFFIX =
  "/free-treat-gift-and-delay";
export const SUBSCRIPTIONS_CUSTOMER_GET_FREE_TREAT_GIFT_PATH_SUFFIX = "/free-treat-gift";

/** /customer/subscription/fresh/free-treat-gift-and-delay */
export const SUBSCRIPTIONS_CUSTOMER_REQUEST_FREE_TREAT_GIFT_AND_DELAY_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_REQUEST_FREE_TREAT_GIFT_AND_DELAY_PATH_SUFFIX
}`;

/** /customer/subscription/fresh/free-treat-gift */
export const SUBSCRIPTIONS_CUSTOMER_GET_FREE_TREAT_GIFT_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_GET_FREE_TREAT_GIFT_PATH_SUFFIX
}`;
